// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Internal Dependencies
import { getThumbnailFromVideoURL } from '../../../common/util';

const SortableVideoItem = ({ id, value, showVideo, imageExists, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <>
      <div style={style}>
        <div ref={setNodeRef} {...attributes} {...listeners}>
          <div style={{ marginBottom: '44px' }}>
            {
              !showVideo && imageExists
                ? (
                  <div style={{ width: 200, height: 200 }}>
                    <img
                      src={`${getThumbnailFromVideoURL(value)}?${Math.random()}`}
                      style={{
                        cursor:       'grabbing',
                        resizeMode:   'contain',
                        borderRadius: '10px',
                        boxShadow:    '0 2px 4px 2px rgba(0, 0, 0, .3)',
                        marginTop:    '4px',
                        minHeight:    200,
                        minWidth:     200,
                        maxHeight:    200,
                        maxWidth:     200,
                      }}
                      alt=""
                    />
                  </div>
                )
                : (
                  <ReactPlayer
                    url={value}
                    width={200}
                    height={200}
                    playing={!showVideo}
                    loop
                    volume={0}
                  />
                )
            }
          </div>
        </div>
      </div>

      <div style={{ display: 'relative' }}>
        {children}
      </div>
    </>
  );
};

export default SortableVideoItem;

SortableVideoItem.propTypes = {
  id:          PropTypes.number.isRequired,
  value:       PropTypes.shape(Object),
  imageExists: PropTypes.bool,
  showVideo:   PropTypes.bool,
  children:    PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

SortableVideoItem.defaultProps = {
  value:       {},
  imageExists: false,
  showVideo:   false,
  children:    null,
};
